import { Component } from '@angular/core';
import { navItems } from './_nav';
import { NavService } from '../../services/nav.service';
import { Console } from 'console';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
})
export class DefaultLayoutComponent {

  public navItems = navItems;

  public perfectScrollbarConfig = {
    suppressScrollX: true,
  };

  constructor(private navService: NavService) {}

  ngOnInit(): void {
    this.navItems = this.navService.getNavItems();
    console.log(`ngOnInit, navItems: ${JSON.stringify(this.navItems)}`);
  }
}
